/**
 * Limites de texto livre que cliente e servidor precisam concordar.
 *
 * Notas da atividade e comentário da sugestão eram 500; um tester bateu no
 * teto (feedback de 20/09/2026) e o PO subiu para 1000 — o mesmo do campo
 * "Saúde" do cartão de emergência. O cliente mostra o contador; o servidor
 * corta no mesmo número, para o que a pessoa vê ser o que fica.
 */
export const NOTAS_MAX = 1000;

/** Corta um texto livre no limite; vazio/só espaço vira `null`. */
export function limitarNota(valor: unknown, max: number = NOTAS_MAX): string | null {
  if (typeof valor !== 'string') return null;
  const texto = valor.trim();
  if (!texto) return null;
  return texto.length > max ? texto.slice(0, max) : texto;
}
